// extracted by mini-css-extract-plugin
export default {"description":"Form_description__T-AO2","button":"Form_button__Oy29y","error":"Form_error__yrG9h","title":"Form_title__F7FaE","buttonDisabled":"Form_buttonDisabled__tLVSw"};